module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-input"
  }, [_c('label', {
    staticClass: "clearfix",
    style: ({
      width: _vm.width ? _vm.width + 'px' : '100%',
      height: _vm.height ? _vm.height + 'px' : 'initial'
    })
  }, [_c('canvas'), _vm._v(" "), (!_vm.srcDefault) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    staticClass: "icon fa fa-picture-o"
  }) : _vm._e(), _vm._v(" "), (_vm.srcDefault) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    class: {
      avatar: _vm.avatar
    },
    attrs: {
      "src": _vm.srcDefault
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preview),
      expression: "preview"
    }],
    class: {
      avatar: _vm.avatar
    },
    attrs: {
      "src": _vm.preview
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "name": "image",
      "type": "file"
    },
    on: {
      "change": _vm.imageChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-load fa fa-upload"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72bad9b6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/f-image.vue
// module id = 663
// module chunks = 1